import axios from 'axios'
import { mapGetCountries } from './mappers.js'
// import getHeaders from '@/api/headersSettings'

let _instance

export async function getBaseHeader (headers) {
  const AXIOS_PARAMS = {
    baseURL: process.env.VUE_APP_API_URL,
    headers
  }

  _instance = axios.create(AXIOS_PARAMS)
  window.axios = axios
}

export async function destinations () {
  const params = {
    url: '/travels/v5/destinations',
    method: 'GET'
  }
  const response = await _instance(params)
  return response.data
}

export async function getCountries () {
  const params = {
    url: '/travels/v1/countries',
    method: 'GET'
  }

  const response = await _instance(params)
  return mapGetCountries(response.data)
}

export async function postLead ({ cookieGA, data }) {
  const params = {
    url: '/internal-commons/v2/lead',
    headers: {
      ...cookieGA && {
        'cookie-ga': cookieGA
      }
    },
    method: 'POST',
    data
  }

  const response = await _instance(params)
  return response
}

export async function patchLead ({ uuid, cookieGA, data }) {
  if (!uuid) return

  const params = {
    url: `/internal-commons/v2/lead/${uuid}`,
    headers: {
      ...cookieGA && {
        'cookie-ga': cookieGA
      }
    },
    method: 'PATCH',
    data
  }

  const response = await _instance(params)
  return response
}

export async function createQuotations (data) {
  const params = {
    url: `/travels/v6/destinations/quotations`,
    method: 'POST',
    data
  }

  const response = await _instance(params)
  return response.data
}

export async function resendVouchers (data) {
  const params = {
    url: '/purchases/vouchers/resend',
    method: 'POST',
    data
  }

  const response = await _instance(params)
  return response
}

export async function getSurveys () {
  const params = {
    url: `/travels/v1/plans/surveys`,
    method: 'GET'
  }

  const response = await _instance(params)

  return response
}

export async function sendSurveyResponse (data, planUuid) {
  const params = {
    url: `/travels/v1/plans/${planUuid}/survey`,
    method: 'POST',
    data
  }

  const response = await _instance(params)
  return response
}

export async function getLaboratoryNetworks () {
  const params = {
    url: '/travels/pcr-exam/v1/laboratory-networks',
    method: 'GET'
  }

  const response = await _instance(params)
  return response.data
}

export async function getLaboratoriesByState (stateUuid) {
  const params = {
    url: `/travels/pcr-exam/v1/laboratory-networks/states/${stateUuid}`,
    method: 'GET'
  }

  const response = await _instance(params)
  return response.data
}

export async function getStates () {
  const params = {
    url: '/travels/pcr-exam/v1/laboratory-networks/states',
    method: 'GET'
  }

  const response = await _instance(params)
  return response.data
}

export async function getQuotationPcrExam (quantity) {
  const params = {
    url: `/travels/pcr-exam/v1/quotations?quantity=${quantity}`,
    method: 'GET'
  }

  const response = await _instance(params)
  return response.data
}

export async function checkPixPayment (uuid) {
  const params = {
    url: `/internal-commons/v1/payments/pixs/${uuid}`,
    method: 'GET'
  }

  const response = await _instance(params)
  return response.data
}

export async function getAppSettings (clientID) {
  const { groups } = /(key-(?<partner>.*)-((ex|in)ternal)-(pr(o)?d|hml|dev))|(key-(?<partner2>.*)-(pr(o)?d|hml|dev))/.exec(clientID) || {}

  const partner = (groups && (groups.partner || groups.partner2)) || 'ciclic'

  const params = {
    url: `https://static.ciclic.com.br/data/partner/${partner}.json`,
    method: 'GET'
  }

  const response = await _instance(params)
  return response.data
}
